module.exports = __webpack_public_path__ + "img/herostatistics.e5530e86.png";